var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusBgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7915 11.041H8.20817V8.20768H11.0415V6.79101H8.20817V3.95768H6.7915V6.79101H3.95817V8.20768H6.7915V11.041ZM7.49984 14.5827C6.51998 14.5827 5.59914 14.3966 4.73734 14.0245C3.87553 13.6524 3.12588 13.1478 2.48838 12.5108C1.85088 11.8733 1.34631 11.1237 0.974671 10.2618C0.603032 9.40004 0.416976 8.47921 0.416504 7.49935C0.416504 6.51949 0.60256 5.59865 0.974671 4.73685C1.34678 3.87504 1.85135 3.12539 2.48838 2.48789C3.12588 1.85039 3.87553 1.34582 4.73734 0.974182C5.59914 0.602543 6.51998 0.416488 7.49984 0.416016C8.4797 0.416016 9.40053 0.602071 10.2623 0.974182C11.1241 1.34629 11.8738 1.85086 12.5113 2.48789C13.1488 3.12539 13.6536 3.87504 14.0257 4.73685C14.3978 5.59865 14.5836 6.51949 14.5832 7.49935C14.5832 8.47921 14.3971 9.40004 14.025 10.2618C13.6529 11.1237 13.1483 11.8733 12.5113 12.5108C11.8738 13.1483 11.1241 13.6531 10.2623 14.0252C9.40053 14.3973 8.4797 14.5832 7.49984 14.5827Z",
    fill: "#003459"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBgIcon);
export default __webpack_public_path__ + "static/media/plusBgIcon.e754b11ddd59c07c5281a23d9ff01d80.svg";
export { ForwardRef as ReactComponent };